import Amplify, { API } from 'aws-amplify';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

import App from './App';
import awsexports from './aws-exports';
import { Loader } from './components/Loader';
import * as serviceWorker from './serviceWorker';
import { config } from './utils';

import './i18n';
import './index.less';

// Load Amplify config first thing, before doing anything Amplify related
Amplify.configure(awsexports);

// Replace renderer url with API endpoint if not set
if (!config.RENDERER_URL) {
  API.endpoint('otsRender').then((value) => {
    config.RENDERER_URL = value;
  });
}

ReactDOM.render(
  <Router>
    <React.Suspense fallback={<Loader />}>
      <App />
    </React.Suspense>
  </Router>,
  document.getElementById('appRoot')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
